import { Descriptions as AntdDescriptions } from 'antd';
import { DescriptionsProps as AntdDescriptionsProps } from 'antd/lib/descriptions';

export type DescriptionsProps = AntdDescriptionsProps;

export const Descriptions = AntdDescriptions;
export default Descriptions;
